import {Injectable} from '@angular/core';
import {RequesterService} from '../../../services/requester.service';
import {ResourceModel} from '../models/resources.model';
import {AnalyticsService} from '../../../services/analytics.service';


@Injectable({
    providedIn: 'root'
})
export class ResourcesService {
    constructor(
        private requesterService: RequesterService,
        private analytics: AnalyticsService,
    ) {
    }

    getResourceList(): Promise<ResourceModel[]> {
        return this.requesterService.get('getMyResourcesList')
            .then(data => {
                if (!!data.result && Array.isArray(data.result) && data.result.length > 0) {
                    return data.result as ResourceModel[];
                }
                return [];
            })
            .catch(e => {
                return [];
                console.log('Error getMyResourcesList >> ', e);
            });
    }

    updateResourceStatus(resource: ResourceModel) {
        const params: ResourceModel = {
            resource_table: resource.resource_table,
            resource_id: resource.resource_id,
            del_id: resource.del_id,
            folder: resource.folder,
            title: resource.title,
            description: resource.description,
            image: resource.image,
            rec: resource.rec,
            type: resource.type,
            link: resource.link,
            link_android: resource.link_android,
            link_universal: resource.link_universal,
            status: !resource.status
        };

        this.analytics.trackEvent('resource_update', {
            resource_id: params.resource_id.toString(),
            resource_table: params.resource_table,
            resource_title: params.title,
            resource_folder: params.folder,
            resource_type: params.type,
            resource_url: params.link,
            resource_status: params.status ? 'confirmed' : 'unconfirmed',
        });
        return this.requesterService.put('updateResourceStatus', params);
    }
}
